import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@rsos/base-components';
import { setChatVisibility } from '@rsos/reduxDataStore/src/features/eventPane/eventPaneSlice';
import { fetchMessages } from '@rsos/reduxDataStore/src/features/preconfiguredMessages';
import { selectUserOrgByApp } from '@rsos/sinatra';
import CallChats from '../../CallChats/CallChats';
import {
  CHAT_SOURCE_ASC,
  CHAT_SOURCE_TF911,
  CHAT_SOURCE_RCS,
} from '../../constants';
import OverviewBanners from './OverviewTab/OverviewBanners';

const ChatsTab = () => {
  const dispatch = useDispatch();
  const orgName = useSelector(
    state =>
      selectUserOrgByApp(
        state.sinatra,
        state.sinatra.user.currentRole.application,
      ).name,
  );

  const chatVisibility = useSelector(state => state.eventPane.chatVisibility);

  const isAgencyShareChatChatBoxVisible =
    chatVisibility.isAgencyShareChatVisible;
  const isTextFrom911ChatBoxVisible = chatVisibility.isTextFrom911ChatVisible;
  const isRcsChatBoxVisible = chatVisibility.isRcsChatVisible;

  useEffect(() => {
    dispatch(fetchMessages(orgName));
  }, []);

  /**
   * Callback function to handle the SplitPane height. Lets the Pane component
   * know which chat is collapsed.
   * @param {String} chatSource - 'asc' or 'tf911
   */
  const handleCollapseChat = useCallback(
    chatSource => {
      if (chatSource === CHAT_SOURCE_ASC) {
        dispatch(
          setChatVisibility({
            chatType: 'isAgencyShareChatVisible',
            isVisible: !isAgencyShareChatChatBoxVisible,
          }),
        );
      } else if (chatSource === CHAT_SOURCE_TF911) {
        dispatch(
          setChatVisibility({
            chatType: 'isTextFrom911ChatVisible',
            isVisible: !isTextFrom911ChatBoxVisible,
          }),
        );
      } else if (chatSource === CHAT_SOURCE_RCS) {
        dispatch(
          setChatVisibility({
            chatType: 'isRcsChatVisible',
            isVisible: !isRcsChatBoxVisible,
          }),
        );
      }
    },
    [
      dispatch,
      isAgencyShareChatChatBoxVisible,
      isTextFrom911ChatBoxVisible,
      isRcsChatBoxVisible,
    ],
  );

  return (
    <Box gridRowGap="16px" height="100%">
      <OverviewBanners />
      <CallChats
        isAgencyShareChatChatBoxVisible={isAgencyShareChatChatBoxVisible}
        isTextFrom911ChatBoxVisible={isTextFrom911ChatBoxVisible}
        isRcsChatBoxVisible={isRcsChatBoxVisible}
        onCollapseChat={handleCollapseChat}
      />
    </Box>
  );
};

export default ChatsTab;
